import api from "@/api"; // Giả định đây là file axios instance đã cấu hình

const API_URL = '/api/noi-quy';

export const NoiQuyApi = {
    /**
     * Lấy danh sách nội quy phân trang
     * @param {Object} params - (page, size, sort, phongBanId, chung)
     * @returns {Promise<Object>} - Trang dữ liệu (Page<NoiQuyDto>)
     */
    // list(params = {}) {
    //     // Lọc ra các param null hoặc undefined
    //     const cleanParams = Object.fromEntries(
    //         Object.entries(params).filter(([_, v]) => v != null)
    //     );
    //     return api.get(API_URL, { params: cleanParams });
    // },
    list(params = {}) {
        return api.get(API_URL, { params: params });
    },
    
    public(params = {}) {
        return api.get(API_URL+'/public', { params: params });
    },

    /**
     * Lấy chi tiết một nội quy
     * @param {number|string} id - ID của nội quy
     * @returns {Promise<Object>} - NoiQuyDto
     */
    getById(id) {
        return api.get(`${API_URL}/${id}`);
    },

    /**
     * Tạo mới một nội quy
     * @param {Object} dto - NoiQuyDto (không cần id)
     * @returns {Promise<Object>} - NoiQuyDto đã tạo
     */
    create(dto) {
        return api.post(API_URL, dto);
    },

    /**
     * Cập nhật một nội quy
     * @param {number|string} id - ID của nội quy
     * @param {Object} dto - NoiQuyDto
     * @returns {Promise<Object>} - NoiQuyDto đã cập nhật
     */
    update(id, dto) {
        return api.put(`${API_URL}/${id}`, dto);
    },

    /**
     * Xóa một nội quy
     * @param {number|string} id - ID của nội quy
     * @returns {Promise<void>}
     */
    remove(id) {
        return api.delete(`${API_URL}/${id}`);
    }
};